<template>
    <div ref="permissionsSelectionBlock">
        <label for="permissions-selection-button" class="mb-1 block text-sm text-gray-500">Права доступа</label>
        <button ref="permissionsSelectionButton" @click="openCloseMultiSelection" id="permissions-selection-button" class="w-full min-h-[2.375rem] text-sm text-gray-900 rounded border border-custom-blue focus:ring-blue-500 focus:border-blue-500 flex justify-between items-center py-2 px-4" type="button">
            <span class="whitespace-nowrap overflow-hidden text-ellipsis max-w-[90%] shrink-0">{{ selectedPermissionsVerboseName || "" }}</span> 
            <svg class="w-2.5 h-2.5 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
            </svg>
        </button>
        <div v-show="isOpened" class="z-10 bg-white absolute rounded-lg shadow w-[23.5rem] dark:bg-gray-700">
            <div @click.stop class="max-h-52 px-3 py-3 overflow-y-auto text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownSearchButton">
                <div class="p-4 grid gap-4">
                    <div class="grid gap-2">
                        <CheckboxInput v-model:checkboxParam="createMovingsAndSupplyingsAndDeleteGoodAmountsPermissionParam" :labelContent="permissionLabels['createMovingsAndSupplyingsAndDeleteGoodAmountsPermission']"/>
                        <CheckboxInput v-model:checkboxParam="addGoodsAndCharacteristicsPermissionParam" :labelContent="permissionLabels['addGoodsAndCharacteristicsPermission']"/>
                        <CheckboxInput v-model:checkboxParam="editGoodsAndCharacteristicsPermissionParam" :labelContent="permissionLabels['editGoodsAndCharacteristicsPermission']"/>
                        <CheckboxInput v-model:checkboxParam="deleteGoodsAndCharacteristicsPermissionParam" :labelContent="permissionLabels['deleteGoodsAndCharacteristicsPermission']"/>
                        <CheckboxInput v-model:checkboxParam="editGeneralGoodCharacteristicsPermissionParam" :labelContent="permissionLabels['editGeneralGoodCharacteristicsPermission']"/>
                    </div>
                    <div class="grid gap-2">
                        <CheckboxInput v-model:checkboxParam="createKassaTransactionsPermissionParam" :labelContent="permissionLabels['createKassaTransactionsPermission']"/>
                        <CheckboxInput v-model:checkboxParam="viewBalancesForPastPeriodsParam" :labelContent="permissionLabels['viewBalancesForPastPeriods']"/>
                        <CheckboxInput v-model:checkboxParam="deleteLastKassaTransactionPermissionParam" @change="handleChangeDeleteLastKasaTrsnactionPermission" :labelContent="permissionLabels['deleteLastKassaTransactionPermission']"/>
                        <CheckboxInput v-model:checkboxParam="deleteKassaTransactionsByLastDayPermissionParam" :disabled="!deleteLastKassaTransactionPermissionParam" :labelContent="permissionLabels['deleteKassaTransactionsByLastDayPermission']"/>
                        <CheckboxInput v-model:checkboxParam="downloadKassaTransactionCSVPermissionParam" :labelContent="permissionLabels['downloadKassaTransactionCSVPermission']"/>
                    </div>
                    <div class="grid gap-2">
                        <CheckboxInput v-model:checkboxParam="viewFullClientBaseUploadAndDownloadClientsPermissionParam" @change="handleChangeViewFullClientBaseUploadAndDownloadClientsPermission" :labelContent="permissionLabels['viewFullClientBaseUploadAndDownloadClientsPermission']"/>
                        <CheckboxInput v-model:checkboxParam="editDiscountPolicyPermissionParam" :disabled="!viewFullClientBaseUploadAndDownloadClientsPermissionParam" :labelContent="permissionLabels['editDiscountPolicyPermission']"/>
                        <CheckboxInput v-model:checkboxParam="deleteAndEditClientPermissionParam" :labelContent="permissionLabels['deleteAndEditClientPermission']"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import CheckboxInput from '@/components/InputComponents/CheckboxInput.vue';

    export default {
        name: "PermissionsMultiSelection",
        components: {
            CheckboxInput,
        },
        props: {
            editGoodsAndCharacteristicsPermission: {
                type: Boolean,
                required: true,
            },
            deleteGoodsAndCharacteristicsPermission: {
                type: Boolean,
                required: true,
            },
            addGoodsAndCharacteristicsPermission: {
                type: Boolean,
                required: true,
            },
            editGeneralGoodCharacteristicsPermission: {
                type: Boolean,
                required: true,
            },
            createKassaTransactionsPermission: {
                type: Boolean,
                required: true,
            },
            deleteLastKassaTransactionPermission: {
                type: Boolean,
                required: true,
            },
            deleteKassaTransactionsByLastDayPermission: {
                type: Boolean,
                required: true,
            },
            downloadKassaTransactionCSVPermission: {
                type: Boolean,
                required: true,
            },
            createMovingsAndSupplyingsAndDeleteGoodAmountsPermission: {
                type: Boolean,
                required: true,
            },
            viewFullClientBaseUploadAndDownloadClientsPermission: {
                type: Boolean,
                required: true,
            },
            deleteAndEditClientPermission: {
                type: Boolean,
                required: true,
            },
            editDiscountPolicyPermission: {
                type: Boolean,
                required: true,
            },
            viewBalancesForPastPeriods: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            editGoodsAndCharacteristicsPermissionParam: {
                get() {
                    return this.editGoodsAndCharacteristicsPermission;
                },
                set(newValue) {
                    this.$emit("update:editGoodsAndCharacteristicsPermission", newValue);
                }
            },
            deleteGoodsAndCharacteristicsPermissionParam: {
                get() {
                    return this.deleteGoodsAndCharacteristicsPermission;
                },
                set(newValue) {
                    this.$emit("update:deleteGoodsAndCharacteristicsPermission", newValue);
                }
            },
            addGoodsAndCharacteristicsPermissionParam: {
                get() {
                    return this.addGoodsAndCharacteristicsPermission;
                },
                set(newValue) {
                    this.$emit("update:addGoodsAndCharacteristicsPermission", newValue);
                }
            },
            editGeneralGoodCharacteristicsPermissionParam: {
                get() {
                    return this.editGeneralGoodCharacteristicsPermission;
                },
                set(newValue) {
                    this.$emit("update:editGeneralGoodCharacteristicsPermission", newValue);
                }
            },
            createKassaTransactionsPermissionParam: {
                get() {
                    return this.createKassaTransactionsPermission;
                },
                set(newValue) {
                    this.$emit("update:createKassaTransactionsPermission", newValue);
                }
            },
            deleteLastKassaTransactionPermissionParam: {
                get() {
                    return this.deleteLastKassaTransactionPermission;
                },
                set(newValue) {
                    this.$emit("update:deleteLastKassaTransactionPermission", newValue);
                }
            },
            deleteKassaTransactionsByLastDayPermissionParam: {
                get() {
                    return this.deleteKassaTransactionsByLastDayPermission;
                },
                set(newValue) {
                    this.$emit("update:deleteKassaTransactionsByLastDayPermission", newValue);
                }
            },
            downloadKassaTransactionCSVPermissionParam: {
                get() {
                    return this.downloadKassaTransactionCSVPermission;
                },
                set(newValue) {
                    this.$emit("update:downloadKassaTransactionCSVPermission", newValue);
                }
            },
            createMovingsAndSupplyingsAndDeleteGoodAmountsPermissionParam: {
                get() {
                    return this.createMovingsAndSupplyingsAndDeleteGoodAmountsPermission;
                },
                set(newValue) {
                    this.$emit("update:createMovingsAndSupplyingsAndDeleteGoodAmountsPermission", newValue);
                }
            },
            viewFullClientBaseUploadAndDownloadClientsPermissionParam: {
                get() {
                    return this.viewFullClientBaseUploadAndDownloadClientsPermission;
                },
                set(newValue) {
                    this.$emit("update:viewFullClientBaseUploadAndDownloadClientsPermission", newValue);
                }
            },
            deleteAndEditClientPermissionParam: {
                get() {
                    return this.deleteAndEditClientPermission;
                },
                set(newValue) {
                    this.$emit("update:deleteAndEditClientPermission", newValue);
                }
            },
            editDiscountPolicyPermissionParam: {
                get() {
                    return this.editDiscountPolicyPermission;
                },
                set(newValue) {
                    this.$emit("update:editDiscountPolicyPermission", newValue);
                }
            },
            viewBalancesForPastPeriodsParam: {
                get() {
                    return this.viewBalancesForPastPeriods;
                },
                set(newValue) {
                    this.$emit("update:viewBalancesForPastPeriods", newValue);
                }
            },
            selectedPermissionsVerboseName() {
                let result = [];
                
                if (this.createMovingsAndSupplyingsAndDeleteGoodAmountsPermission) {
                    result.push(this.permissionLabels["createMovingsAndSupplyingsAndDeleteGoodAmountsPermission"])
                }
                if (this.addGoodsAndCharacteristicsPermission) {
                    result.push(this.permissionLabels["addGoodsAndCharacteristicsPermission"])
                }
                if (this.editGoodsAndCharacteristicsPermission) {
                    result.push(this.permissionLabels["editGoodsAndCharacteristicsPermission"])
                }
                if (this.deleteGoodsAndCharacteristicsPermission) {
                    result.push(this.permissionLabels["deleteGoodsAndCharacteristicsPermission"])
                }
                if (this.editGeneralGoodCharacteristicsPermission) {
                    result.push(this.permissionLabels["editGeneralGoodCharacteristicsPermission"])
                }

                if (this.createKassaTransactionsPermission) {
                    result.push(this.permissionLabels["createKassaTransactionsPermission"])
                }
                if (this.viewBalancesForPastPeriods) {
                    result.push(this.permissionLabels["viewBalancesForPastPeriods"])
                }
                if (this.deleteLastKassaTransactionPermission) {
                    result.push(this.permissionLabels["deleteLastKassaTransactionPermission"])
                }
                if (this.deleteKassaTransactionsByLastDayPermission) {
                    result.push(this.permissionLabels["deleteKassaTransactionsByLastDayPermission"])
                }
                if (this.downloadKassaTransactionCSVPermission) {
                    result.push(this.permissionLabels["downloadKassaTransactionCSVPermission"])
                }

                if (this.viewFullClientBaseUploadAndDownloadClientsPermission) {
                    result.push(this.permissionLabels["viewFullClientBaseUploadAndDownloadClientsPermission"])
                }
                if (this.editDiscountPolicyPermission) {
                    result.push(this.permissionLabels["editDiscountPolicyPermission"])
                }
                if (this.deleteAndEditClientPermission) {
                    result.push(this.permissionLabels["deleteAndEditClientPermission"])
                }

                return result.join(", ")
            },
        },
        data() {
            return {
                isOpened: false,
                permissionLabels: {
                    "createMovingsAndSupplyingsAndDeleteGoodAmountsPermission": "Создавать поставки и перемещения товаров и удалять товарные остатки",
                    "addGoodsAndCharacteristicsPermission": "Добавлять товары и их характеристики",
                    "editGoodsAndCharacteristicsPermission": "Редактировать товары и их характеристики",
                    "deleteGoodsAndCharacteristicsPermission": "Удалять товары и их характеристики",
                    "editGeneralGoodCharacteristicsPermission": "Редактировать общие характеристики товаров ",
                    "createKassaTransactionsPermission": "Создавать кассовые операции",
                    "viewBalancesForPastPeriods": "Просмотр балансов за прошлые периоды",
                    "deleteLastKassaTransactionPermission": "Удалять последнюю кассовую операцию",
                    "deleteKassaTransactionsByLastDayPermission": "Удалять кассовые операции за последний день",
                    "downloadKassaTransactionCSVPermission": "Выгружать кассовые операции в CSV",
                    "viewFullClientBaseUploadAndDownloadClientsPermission": "Просмотр полной клиентской базы. Загрузка и выгрузка клиентов",
                    "editDiscountPolicyPermission": "Редактировать политики скидок",
                    "deleteAndEditClientPermission": "Удалять и редактировать клиентов",
                }
            }
        },
        methods: {
            handleChangeViewFullClientBaseUploadAndDownloadClientsPermission() {
                if (this.viewFullClientBaseUploadAndDownloadClientsPermissionParam) return
                this.editDiscountPolicyPermissionParam = false;
            },
            handleChangeDeleteLastKasaTrsnactionPermission() {
                if (this.deleteLastKassaTransactionPermissionParam) return;
                this.deleteKassaTransactionsByLastDayPermissionParam = false;
            },
            openCloseMultiSelection() {
                this.isOpened = !this.isOpened;
            },
            addAutoCloseMultiSelection() {
                document.body.addEventListener("click", (event) => {
                    const permissionsSelectionBlock = this.$refs.permissionsSelectionBlock;
                    if (permissionsSelectionBlock && permissionsSelectionBlock.contains(event.target)) {
                        return;
                    }
                    this.isOpened = false;
                })
            },
        },
        mounted() {
            this.addAutoCloseMultiSelection();
        }
    }
</script>